import React from 'react';
import { StyledCheckedIcon, StyledContainer, StyledFormMessage, StyledIconContainer, StyledInput, StyledLabel, StyledPill, StyledUncheckedIcon } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const ToggleSwitch = ({ id, label, name, value, className, onChange, disabled, onClick, checked, hint, defaultChecked, labelPosition = 'trailing', margin, ...rest }) => {
    const hintId = `${id}__hint`;
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const ariaDescribedBy = hint || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    return (React.createElement(StyledContainer, { className: className, margin: margin, ...dataProps },
        React.createElement(StyledLabel, { disabled: disabled, labelPosition: labelPosition },
            React.createElement(StyledInput, { id: id, type: "checkbox", name: name, value: value, onChange: onChange, onClick: onClick, disabled: disabled, checked: checked, defaultChecked: defaultChecked, ...a11yProps, "aria-describedby": ariaDescribedBy }),
            labelPosition === 'leading' && label,
            React.createElement(StyledPill, null,
                React.createElement(StyledIconContainer, null,
                    React.createElement(StyledCheckedIcon, { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
                        React.createElement("path", { fill: "currentColor", d: "M7 4H8V12H7V4Z" })),
                    React.createElement(StyledUncheckedIcon, { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
                        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5ZM8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6Z" })))),
            labelPosition === 'trailing' && label),
        hint && (React.createElement(StyledFormMessage, { text: hint, variant: "hint", id: hintId, labelPosition: labelPosition, disabled: disabled }))));
};
//# sourceMappingURL=index.js.map